import { Controller } from "@hotwired/stimulus"

// Inline-edit a funding client's Business Funding stage (QAN-325 follow-up).
// Each stage <select> in the Funding Clients table carries its own data-url and
// data-original. On change we PATCH the new stage and autosave, reverting the
// dropdown if the request fails.
export default class extends Controller {
  async update(event) {
    const select = event.target
    const url = select.dataset.url
    const newValue = select.value
    const status = this.statusFor(select)

    this.setStatus(status, "Saving…", "text-gray-400")

    const csrfMeta = document.querySelector('meta[name="csrf-token"]')
    const csrfToken = csrfMeta ? csrfMeta.content : ""

    try {
      const response = await fetch(url, {
        method: "PATCH",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({ stage: newValue })
      })

      if (response.ok) {
        select.dataset.original = newValue
        this.setStatus(status, "Saved", "text-green-600")
      } else {
        this.revert(select, status)
      }
    } catch (error) {
      this.revert(select, status)
    }
  }

  // ── Private helpers ──

  statusFor(select) {
    return select.closest("td")?.querySelector("[data-stage-status]")
  }

  revert(select, status) {
    select.value = select.dataset.original || ""
    this.setStatus(status, "Error", "text-red-600")
  }

  setStatus(el, text, className) {
    if (!el) return
    el.textContent = text
    el.className = `text-xs ${className}`
  }
}
